import { useEffect, useRef } from 'react';
import { API_BASE_URL } from '../services/ApiService';

const HEARTBEAT_INTERVAL = 15_000; // 15 seconds
const SESSION_KEY = 'plm_visitor_session_id';

function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function useHeartbeat() {
  const intervalRef = useRef(null);

  useEffect(() => {
    const sessionId = getSessionId();

    const sendHeartbeat = () => {
      // Skip if tab is hidden (Page Visibility API)
      if (document.hidden) return;

      fetch(`${API_BASE_URL}/heartbeat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId }),
      }).catch(() => { /* silently ignore */ });
    };

    // Send immediately on mount
    sendHeartbeat();

    // Then repeat every 15s
    intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
}
